import { useEffect, useState, useRef } from "react";
import { WifiOff } from "lucide-react";
import { toast } from "sonner";

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const wasOffline = useRef(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => { setOffline(true); wasOffline.current = true; };
    const goOnline = () => {
      setOffline(false);
      if (wasOffline.current) {
        wasOffline.current = false;
        toast.success("Conexão restabelecida. Atualizando…");
        // Reconexão suave: revalida dados das telas sem recarregar a página
        setTimeout(() => window.dispatchEvent(new Event("app:reconnect")), 300);
      }
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 inset-x-0 z-[10000] flex items-center justify-center gap-2 h-9 text-sm font-medium text-white"
      style={{ backgroundColor: "#8A2E2E", boxShadow: "0 2px 10px rgba(0,0,0,0.35)" }}
    >
      <WifiOff className="h-4 w-4" /> Você está offline. Verifique sua conexão.
    </div>
  );
}
